import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Es esto legal?',
  a: 'Sí. Estos programas son obligatorios por mandato federal del IRS.'
}, {
  q: '¿Necesito una computadora?',
  a: 'No, puedes hacer todo desde cualquier teléfono inteligente.'
}, {
  q: '¿Funciona para quienes tienen ITIN?',
  a: 'Sí, la guía muestra los caminos específicos para portadores de ITIN.'
}, {
  q: '¿Qué pasa si ya empecé en otro sitio?',
  a: 'Puedes cambiarte al camino gratuito en cualquier momento antes de pagar.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-offwhite py-20 md:py-28" data-id="element-25">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-26">
        <div className="text-center mb-12" data-id="element-27">
          <h2 className="text-4xl font-bold text-navy-dark uppercase mb-4" data-id="element-28">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-29">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-30">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === idx} data-id="element-31">
                <span className="text-xl font-heading font-bold text-navy-dark" data-id="element-32">
                  {faq.q}
                </span>
                <motion.div animate={{
              rotate: openIndex === idx ? 180 : 0
            }} transition={{
              duration: 0.2
            }} data-id="element-33">
                  <ChevronDown className="w-6 h-6 text-gold-accent" data-id="element-34" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-35">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-36">
                    <div className="px-6 pb-5 text-gray-600 font-body text-lg" data-id="element-37">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}